import React, {useEffect, useState} from 'react'
import {Row,  Form } from "react-bootstrap";
import { useFormik } from 'formik';
import * as FormFields from "../../../../../components/formcomponents"
import { IndustryList } from '../../../../../helpers/API/Api';
function Index(props) {
    const formik = useFormik({
        initialValues:
        props.isEdit == true ? 
        {
            customerIndustryTypeID: props.dataForEdit.customerdata.customerIndustryTypeID,
            numberOfManufacturingSite: props.dataForEdit.customerdata.numberOfManufacturingSite,
            numberOfStorageFacilities: props.dataForEdit.customerdata.numberOfStorageFacilities,
        }
        
        :
        
        {
            customerIndustryTypeID: null,
            numberOfManufacturingSite: 0,
            numberOfStorageFacilities: 0,
        },
      
        validate: values => {
            
            let errors = {}

            const letters = /^[A-Za-z ]+$/;
            
            if(!values.parentCompanyUnitNo){
                errors.parentCompanyUnitNo = "Please fill in Name"
            }
            return errors
        }

        
    })
    useEffect(()=>{
        formik.values.customerIndustryTypeID =  formik.values.customerIndustryTypeID != null ? parseInt(formik.values.customerIndustryTypeID) : formik.values.customerIndustryTypeID
        formik.values.numberOfManufacturingSite = parseInt(formik.values.numberOfManufacturingSite)
        formik.values.numberOfStorageFacilities = parseInt(formik.values.numberOfStorageFacilities)
        props.saveMarketingInformation(formik.values)
    }, [formik])

  return (
    <Row className='d-flex p-2-rem' style={{background: '#fff'}}>
    <div className = 'd-flex justify-content-between'>
        <div className='font-16 font-weight-600 color-707895'>
        Marketing Information
        </div>
    </div>
    <Row className='d-flex'>
                <Row>
                    <FormFields.InputSelect
                        md={3}
                        name='customerIndustryTypeID'
                        label='Industry'
                        classname='pt-1-rem'
                        type='text'
                        optionField = {props.isEdit == true ? <IndustryList customerIndustryTypeID = {props.dataForEdit.customerdata.customerIndustryTypeID}/> : <IndustryList/>}
                        onChange={formik.handleChange}
                        onBlur = {formik.handleBlur}
                    />
                    <FormFields.InputField
                        md={3}
                        name='numberOfManufacturingSite'
                        label='No. of Manufacturing Sites'
                        classname='pt-1-rem'
                        type='text'
                        val={parseInt(formik.values.numberOfManufacturingSite)}
                        onChange={formik.handleChange}
                        onBlur = {formik.handleBlur}
                    />
                    <FormFields.InputField
                        md={3}
                        name='numberOfStorageFacilities'
                        label='No. of Storage Facilities'
                        classname='pt-1-rem'
                        type='text'
                        val={parseInt(formik.values.numberOfStorageFacilities)}
                        onChange={formik.handleChange}
                        onBlur = {formik.handleBlur}
                    />
                 
                </Row>
    </Row>
    </Row>
  )
}

export default Index